import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";

const ABOUT_IMG = "https://images.unsplash.com/photo-1611021061285-16c871740efa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx3b29kd29ya2luZyUyMGNyYWZ0c21hbnxlbnwwfHx8fDE3ODExNzc0OTV8MA&ixlib=rb-4.1.0&q=85";

export default function AboutPage() {
    return (
        <div data-testid="about-page">
            <section className="container-padded section-spacing">
                <div className="grid md:grid-cols-12 gap-12 items-start">
                    <div className="md:col-span-6">
                        <div className="overline mb-4">Our Story</div>
                        <h1 className="font-serif text-5xl md:text-6xl text-ink leading-[1.05]">A family of woodworkers, still bench-side after seventeen years.</h1>
                    </div>
                    <div className="md:col-span-6">
                        <div className="aspect-[4/5] overflow-hidden">
                            <img src={ABOUT_IMG} alt="Workshop" className="w-full h-full object-cover" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="container-padded pb-20 md:pb-28">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="overline mb-3">Est. 2008</div>
                        <div className="font-serif text-3xl text-ink">Mohali, Punjab</div>
                    </div>
                    <div className="md:col-span-8 space-y-6 text-lg text-stone-muted leading-relaxed">
                        <Reveal>
                            <p>{`Jassi Wood Works began with a single bench, three carpenters and one principle — that wood deserves to be worked slowly, by hand, with respect.`}</p>
                        </Reveal>
                        <Reveal delay={100}>
                            <p>Seventeen years later, we're still that workshop — only larger, with a design studio attached and a team of fifteen craftsmen. We design, build and install custom furniture, modular kitchens, doors and full interior fit-outs for homes, offices and boutique commercial projects across Punjab, Haryana, Delhi and Himachal.</p>
                        </Reveal>
                        <Reveal delay={150}>
                            <p>Every project passes through the same five hands — design, joinery, finishing, polish, install — and is signed off by Jassi himself.</p>
                        </Reveal>
                    </div>
                </div>
            </section>

            <section className="bg-sand section-spacing">
                <div className="container-padded grid md:grid-cols-3 gap-10">
                    {[
                        { n: "17+", l: "Years of Craft" },
                        { n: "600+", l: "Projects Delivered" },
                        { n: "15", l: "Craftsmen on the Bench" },
                    ].map((s) => (
                        <div key={s.l} className="border-t border-walnut/30 pt-6">
                            <div className="font-serif text-6xl text-walnut">{s.n}</div>
                            <div className="text-xs uppercase tracking-widest text-stone-muted mt-3">{s.l}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="container-padded section-spacing">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="overline mb-3">What We Care About</div>
                        <h2 className="font-serif text-4xl text-ink leading-tight">Three things we will not compromise on.</h2>
                    </div>
                    <div className="md:col-span-7 space-y-8">
                        {[
                            { t: "Material honesty", d: "Solid wood where it should be solid. Engineered substrates only where they genuinely perform better. We name every species we use, on the invoice." },
                            { t: "Joinery before glue", d: "Mortise & tenon, dovetails, dowels, splines — used as the design demands. Glue is a backup, not a strategy." },
                            { t: "We finish what we build", d: "Our installers are the same people who built it. Site issues are handled in hours, not weeks." },
                        ].map((v, i) => (
                            <div key={v.t} className="border-t border-stone-border pt-6">
                                <div className="text-sm text-walnut-light tracking-widest mb-2">0{i + 1}</div>
                                <div className="font-serif text-2xl text-ink">{v.t}</div>
                                <p className="text-stone-muted mt-2 leading-relaxed">{v.d}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="bg-walnut text-cream py-20 md:py-24">
                <div className="container-padded flex flex-col md:flex-row md:items-center md:justify-between gap-8">
                    <h2 className="font-serif text-4xl md:text-5xl leading-tight max-w-2xl">Visit the workshop, see the work, meet the team.</h2>
                    <Link to="/contact" data-testid="about-bottom-cta" className="bg-cream text-walnut px-8 py-4 text-sm tracking-wider uppercase hover:bg-sand transition-colors self-start md:self-auto">
                        Plan a visit
                    </Link>
                </div>
            </section>
        </div>
    );
}
